<div class="container d-flex flex-column align-items-center justify-content-center vh-100">
    <div class="card text-center p-4" style="max-width: 400px;">
        <i class="{{aprobedpayment ? 'iconaprob' : 'iconaprobRec'}} lni {{aprobedpayment ? 'lni-checkmark-circle' : 'lni-cross-circle'}}"></i>
      <h3 class="m-3">{{titlepayment}}</h3>
      <p>
        {{bodymessage}}
      </p>
    </div>
  </div>